export const STORAGE_KEYS = {
  LANGUAGE: 'language',
  ASSET_GROUP: 'assetGroup',
  THEME: 'theme',
  USER_KEY: 'userKey',
};
